export default class AuthenticatedData {
  getData = async (token) => {
    const response = await this.callApi(token);

    return response.json();
  };

  callApi = async (token) => {
    return await fetch(
      `https://3srkiwvwyf.execute-api.us-east-1.amazonaws.com/Prod/get-api-key/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  };
}
